// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._comparisonList_jzyfd_1 {
  --pa-comparison-list-padding-inner: var(
    --pa-comparison-list-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 0 var(--perxis-auto-gap-vertical-orange-inner) 0
  );
  --pa-comparison-list-sticky-box-shadow-inner: var(--pa-comparison-list-sticky-box-shadow, 0px 0px 20px 0px #16161633);
  position: relative;
  padding: var(--pa-comparison-list-padding-inner);
  width: 100%;
  background-color: var(--perxis-auto-root-first-color-inner);
  pointer-events: all;
  clip-path: inset(0 0 -20px 0);
  box-shadow: none;
  transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  --pa-comparison-list-tile-gallery-max-width-inner: var(--pa-comparison-list-tile-gallery-max-width, 100%);
}
._comparisonList_jzyfd_1 .perxis-auto-1_18_1-car-tile-gallery-wrapper {
  position: static;
  max-width: var(--pa-comparison-list-tile-gallery-max-width-inner);
  left: 0;
}
._comparisonList_jzyfd_1 .perxis-auto-1_18_1-car-tile-image {
  top: 0;
  left: 0;
  transform: none;
  width: 100%;
  max-width: var(--pa-comparison-list-tile-gallery-max-width-inner);
}
._comparisonList_jzyfd_1 .perxis-auto-1_18_1-car-tile-image-wrapper {
  position: static;
  width: 100%;
  max-width: var(--pa-comparison-list-tile-gallery-max-width-inner);
  left: 0;
}
._comparisonList--sticky_jzyfd_35 {
  box-shadow: var(--pa-comparison-list-sticky-box-shadow-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-sky-inner);
  --pa-comparison-list-compact-tile-gallery-max-width-inner: var(
    --pa-comparison-list-compact-tile-gallery-max-width,
    165px
  );
}
._comparisonList--sticky_jzyfd_35 .perxis-auto-1_18_1-car-tile-gallery-wrapper {
  max-width: var(--pa-comparison-list-compact-tile-gallery-max-width-inner);
}
._comparisonList--sticky_jzyfd_35 .perxis-auto-1_18_1-car-tile-image {
  max-width: var(--pa-comparison-list-compact-tile-gallery-max-width-inner);
}
._comparisonList--sticky_jzyfd_35 .perxis-auto-1_18_1-car-tile-image-wrapper {
  max-width: var(--pa-comparison-list-compact-tile-gallery-max-width-inner);
}
._comparisonList_jzyfd_1 ._comparisonList__body_jzyfd_52 {
  --pa-comparison-list-body-min-height-inner: var(--pa-comparison-list-body-min-height, fit-content);
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: var(--pa-comparison-list-body-min-height-inner);
}
@media (max-width: 768px) {
  ._comparisonList_jzyfd_1 ._comparisonList__body_jzyfd_52 {
    margin-top: 0;
  }
}
._comparisonList_jzyfd_1 ._comparisonList__item_jzyfd_65 {
  --pa-comparison-list-item-title-font-size-xxs-xs-inner: var(
    --pa-comparison-list-item-title-font-size-xxs-xs,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --pa-comparison-list-item-title-font-size-sm-xxl-inner: var(
    --pa-comparison-list-item-title-font-size-sm-xxl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --pa-comparison-list-item-price-font-size-xxs-xs-inner: var(
    --pa-comparison-list-item-price-font-size-xxs-xs,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --pa-comparison-list-item-price-font-size-sm-xxl-inner: var(
    --pa-comparison-list-item-price-font-size-sm-xxl,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: var(--perxis-auto-gap-vertical-sky-inner);
  overflow: hidden;
  --perxis-auto-car-tile-image-border-radius: 0;
  --perxis-auto-car-tile-image-padding: 0;
  --perxis-auto-car-tile-gallery-padding: 0;
  --perxis-auto-car-tile-gallery-border-radius: 0;
  --perxis-auto-car-tile-padding: 0;
}
@media (min-width: 576px) {
  ._comparisonList_jzyfd_1 ._comparisonList__item_jzyfd_65 {
    --perxis-auto-car-tile-title-heading-font-size: var(--pa-comparison-list-item-title-font-size-sm-xxl-inner);
    --perxis-auto-car-tile-price-discount-price-font-size: var(
      --pa-comparison-list-item-price-font-size-sm-xxl-inner
    );
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  ._comparisonList_jzyfd_1 ._comparisonList__item_jzyfd_65 {
    --perxis-auto-car-tile-title-heading-font-size: var(--pa-comparison-list-item-title-font-size-xxs-xs-inner);
    --perxis-auto-car-tile-price-discount-price-font-size: var(
      --pa-comparison-list-item-price-font-size-xxs-xs-inner
    );
  }
}
._comparisonList_jzyfd_1 ._comparisonList__item_jzyfd_65 > a {
  display: inline-flex;
  flex-direction: column;
  flex-grow: 1;
}
._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  grid-auto-rows: 0;
  overflow: hidden;
}
@media (min-width: 1200px) {
  ._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 36px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  ._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 28px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  ._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  ._comparisonList_jzyfd_1 ._comparisonList__track_jzyfd_114 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
